import { Card } from '@/components/ui/Card';

interface AttendanceStatsProps {
    summary: {
        total: number;
        present: number;
        absent: number;
        late: number;
        leave: number;
        messageSent: number;
    };
    loading?: boolean;
}

export function AttendanceStatsCards({ summary, loading }: AttendanceStatsProps) {
    if (loading) return <div className="h-32 bg-slate-50 animate-pulse rounded-xl" />;

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* Total Students (Not Clickable) */}
            <Card className="p-4 bg-white border-slate-200">
                <div className="text-sm text-slate-500 font-medium">Total Students</div>
                <div className="text-3xl font-bold text-slate-900 mt-1">{summary.total}</div>
            </Card>

            {/* Absentees (Clickable) */}
            <Card className="p-4 bg-rose-50 border-rose-100 cursor-pointer hover:shadow-md transition-all">
                <div className="text-sm text-rose-600 font-medium">Total Absentees</div>
                <div className="text-3xl font-bold text-rose-800 mt-1">{summary.absent}</div>
                <div className="text-xs text-rose-500 mt-2">Click to view list</div>
            </Card>

            {/* Latecomers (Clickable) */}
            <Card className="p-4 bg-amber-50 border-amber-100 cursor-pointer hover:shadow-md transition-all">
                <div className="text-sm text-amber-600 font-medium">Latecomers</div>
                <div className="text-3xl font-bold text-amber-800 mt-1">{summary.late}</div>
                <div className="text-xs text-amber-500 mt-2">Click to view list</div>
            </Card>

            <Card className="p-4 bg-slate-50 border-slate-200">
                <div className="text-sm text-slate-500 font-medium">SMS</div>
                <div className="text-lg font-semibold text-slate-700 mt-1">Not set up yet</div>
                <div className="text-xs text-slate-500 mt-2">Does not send messages</div>
            </Card>
        </div>
    );
}
